import { gql } from 'urql';

export const LIST_INVENTARIOS = gql`
  query ListInventarios($filters: InventarioFilterInput, $pagination: PaginationInput) {
    listInventarios(filters: $filters, pagination: $pagination) {
      items {
        id
        sucursalId
        sucursalNombre
        fechaInicio
        fechaCierre
        estado
        observacion
        items {
          id
          productoId
          productoDescripcion
          stockSistema
          stockFisico
          diferencia
        }
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_INVENTARIO = gql`
  query GetInventario($id: ID!) {
    getInventario(id: $id) {
      id
      sucursalId
      sucursalNombre
      fechaInicio
      fechaCierre
      estado
      observacion
      items {
        id
        productoId
        productoCodigo
        productoDescripcion
        stockSistema
        stockFisico
        diferencia
        observacion
      }
    }
  }
`;

export const INVENTARIO_DIFERENCIAS = gql`
  query InventarioDiferencias($id: ID!) {
    inventarioDiferencias(id: $id) {
      productoId
      productoCodigo
      productoDescripcion
      stockSistema
      stockFisico
      diferencia
    }
  }
`;

export const ABRIR_INVENTARIO = gql`
  mutation AbrirInventario($input: AbrirInventarioInput!) {
    abrirInventario(input: $input) {
      id
    }
  }
`;

export const REGISTRAR_CONTEO = gql`
  mutation RegistrarConteo($input: RegistrarConteoInput!) {
    registrarConteo(input: $input) {
      id
    }
  }
`;

export const CERRAR_INVENTARIO = gql`
  mutation CerrarInventario($id: ID!) {
    cerrarInventario(id: $id) {
      id
      estado
      fechaCierre
    }
  }
`;
